import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getSPVs } from 'src/api/stoApi';
import { SPV } from 'src/models';
import { generalStore } from 'src/stores/GeneralStore';

export const useSPVs = () => {
  const [spvs, setSpvs] = useState<SPV[] | null>(null);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        const response = await getSPVs();
        setSpvs(response.data.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    load();
  }, []);

  return spvs;
};
